var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_3777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_3777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.811 0H0V15H16.811V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_3777)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7865 0H15.9605C16.1856 0.000264653 16.4014 0.0897976 16.5605 0.248959C16.7197 0.40812 16.8092 0.623912 16.8095 0.849V3.749H3.9375V0.849C3.93776 0.623912 4.02729 0.40812 4.18645 0.248959C4.34561 0.0897976 4.56141 0.000264653 4.7865 0Z",
    fill: "#41A6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8115 3.75H3.9375V7.5H16.8115V3.75Z",
    fill: "#297DD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8115 7.5H3.9375V11.25H16.8115V7.5Z",
    fill: "#105ABD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8115 11.25V14.158C16.8096 14.382 16.7194 14.5961 16.5604 14.7538C16.4013 14.9115 16.1865 15 15.9625 15H4.7865C4.56254 15 4.34765 14.9115 4.18863 14.7538C4.02961 14.5961 3.93935 14.382 3.9375 14.158V11.25H16.8115Z",
    fill: "#073D93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.842001 3.14798H7.687C7.91209 3.14824 8.12788 3.23777 8.28704 3.39693C8.4462 3.5561 8.53574 3.77189 8.536 3.99698V10.936C8.53574 11.1611 8.4462 11.3769 8.28704 11.536C8.12788 11.6952 7.91209 11.7847 7.687 11.785H0.842001C0.617874 11.7831 0.403571 11.6927 0.245835 11.5335C0.0880987 11.3743 -0.000270991 11.1591 6.24283e-07 10.935V3.99598C-6.98828e-06 3.77202 0.0884794 3.55712 0.246187 3.3981C0.403895 3.23908 0.618047 3.14882 0.842001 3.14697",
    fill: "#1766CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58661 9.68605L1.34961 5.24805H2.35861L3.08761 8.15605L3.76961 5.24805H4.75861L5.40661 8.15605L6.16161 5.24805H7.17761L5.92761 9.68605H4.91461L4.25261 6.83205L3.58461 9.68605H2.58661Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_3777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.811,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.53379c3d0534554a2fb4240d1ff4f083.svg";
export { ForwardRef as ReactComponent };